<template>
  <main class="relative">
    <div
      v-if="envMessage"
      class="bg-purple-200 h-4 absolute w-full z-50"
    >
      <p class="text-center text-black text-xs">
        {{ envMessage }}
      </p>
    </div>

    <!-- Plain overlay (not AlertDialog): closed reka-ui Presence + ResizeObserver
         throws when a dialog stays mounted with open=false. -->
    <Teleport to="body">
      <div
        v-if="loading"
        class="fixed inset-0 z-[100] flex items-center justify-center bg-black/80"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div class="rounded-lg border bg-background px-8 py-6 shadow-lg min-w-xs w-fit text-center space-y-3">
          <Spinner class="mx-auto size-6" />
          <p
            v-if="currentMessage"
            class="text-sm text-muted-foreground"
          >
            {{ currentMessage }}
          </p>
        </div>
      </div>
    </Teleport>

    <Toaster
      position="top-right"
      rich-colors
    />
    <RouterView />
    <VersionCheck />
  </main>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { Toaster } from 'vue-sonner'
import { useLoaderStore } from '@/stores'
import Spinner from './components/common/Spinner.vue'
import VersionCheck from '@/components/VersionCheck.vue'
import 'vue-sonner/style.css'

const loaderStore = useLoaderStore()
const { loading, currentMessage } = storeToRefs(loaderStore)

const envMessage = (() => {
  const host = window.location.origin
  if (host === 'https://staging.complyone.laradev.cloud') {
    return 'You are in staging environment.'
  } else if (host === 'https://testing.complyone.laradev.cloud') {
    return 'You are in testing environment.'
  }
  return null
})()
</script>
